import styled from 'styled-components'
import layout from '../../tokens/layout'
import colors from '../../tokens/colors'
import border from '../../tokens/border'
import FontFamilyToken from '../../tokens/fonts'

export const ModalArea = styled.section`
  display: grid;
  position: fixed;
  right: ${layout.margin.spacingNone};
  bottom: ${layout.margin.spacingNone};
  top: ${layout.margin.spacingNone};
  left: ${layout.margin.spacingNone};
  background: rgba(0, 0, 0, 0.3);
  justify-content: center;
  align-items: center;
  max-height: 100vh;
  overflow-y: auto;
  padding: ${layout.padding.spacingInsetNano};
  font-family: ${FontFamilyToken.inter};
  z-index: 999;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.1s;

  @keyframes fadeInOpacity {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`

export const Container = styled.div`
  background: ${colors.neutralColorHighPure};
  padding: ${layout.padding.spacingInsetXs} ${layout.padding.spacingInsetNone};
  border-radius: ${border.radius.radiusSm};
  min-width: ${layout.margin.spacingGiant};
`
